import { jsxs as m, jsx as c } from "react/jsx-runtime";
import l, { useState as p, useRef as O, useEffect as x } from "react";
import { FlexCol as j } from "../FlexCol/index.js";
import { FlexRow as w } from "../FlexRow/index.js";
var v = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, d = l.createContext && /* @__PURE__ */ l.createContext(v), P = ["attr", "size", "title"];
function C(e, t) {
  if (e == null)
    return {};
  var r = S(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function S(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function s() {
  return s = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s.apply(this, arguments);
}
function g(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function u(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? g(Object(r), !0).forEach(function(n) {
      E(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function E(e, t, r) {
  return t = N(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function N(e) {
  var t = _(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function _(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function h(e) {
  return e && e.map((t, r) => /* @__PURE__ */ l.createElement(t.tag, u({
    key: r
  }, t.attr), h(t.child)));
}
function y(e) {
  return (t) => /* @__PURE__ */ l.createElement(D, s({
    attr: u({}, e.attr)
  }, t), h(e.child));
}
function D(e) {
  var t = (r) => {
    var {
      attr: n,
      size: i,
      title: a
    } = e, b = C(e, P), f = i || r.size || "1em", o;
    return r.className && (o = r.className), e.className && (o = (o ? o + " " : "") + e.className), /* @__PURE__ */ l.createElement("svg", s({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, b, {
      className: o,
      style: u(u({
        color: e.color || r.color
      }, r.style), e.style),
      height: f,
      width: f,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && /* @__PURE__ */ l.createElement("title", null, a), e.children);
  };
  return d !== void 0 ? /* @__PURE__ */ l.createElement(d.Consumer, null, (r) => t(r)) : t(v);
}
function R(e) {
  return y({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z" }, child: [] }] })(e);
}
function z(e) {
  return y({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" }, child: [] }] })(e);
}
function k({ item: e, isOpen: t, handleClick: r }) {
  const [n, i] = p(""), a = O(null);
  return x(() => {
    a.current && i(`${a.current.clientHeight}px`);
  }, []), /* @__PURE__ */ m(j, { children: [
    /* @__PURE__ */ c("div", { className: "p-2 bg-layerTertiary text-textTertiary hover:bg-layerSecondary hover:text-textSecondary hover:cursor-pointer", onClick: r, children: /* @__PURE__ */ m(w, { className: "justify-between", children: [
      e.label,
      t ? /* @__PURE__ */ c(R, {}) : /* @__PURE__ */ c(z, {})
    ] }) }),
    /* @__PURE__ */ c(
      "div",
      {
        className: "bg-layerSecondary transition-[max-height] overflow-y-hidden",
        style: { maxHeight: t ? n : "0px" },
        children: /* @__PURE__ */ c("div", { ref: a, children: e.content })
      }
    )
  ] });
}
export {
  k as AccordionTile
};
